import { BuildRulesetQuery } from '../../../interfaces/Rulesets';
import { extractJsonFieldSql } from '../../extractJsonFieldSql';

export const selectFields_Ruleset6_PI_6W_EPIV: string = `
    CASE WHEN lownoise.bestlabel is not null OR count.count = 1 then 2 else 1 end as rank,
    id,
    label,
    attributes`;

export const order_Ruleset6_PI_6W_EPIV = 'rank DESC, label';

// 6-way EPIV or PIQCV

export const buildQuery_Ruleset6_PI_6W_EPIV: BuildRulesetQuery = ({
    selectFields,
    rawName,
    filter,
    volumetricFlow,
    volumetricFlow2
}): [string, string[]] => {
    return [
        `WITH product_filtered as (SELECT
               ifnull(cast(attrsVmaxlown.value as float), 0)  as Vmaxlown,
               ifnull(cast(attrsDN.value as float), 0) as DN,
               ifnull(cast(attrsVnom.value as float), 0)  as vnom,
               attrsLine.value as line,
               product.id,
               label,
               attributes
           FROM product
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `$.7456.${rawName}`)}) as attrsVmaxlown
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `$.15.${rawName}`)}) as attrsDN
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `$.7153.${rawName}`)}) as attrsVnom
                    LEFT JOIN json_each(${extractJsonFieldSql('attributes', `$.7266.${rawName}`)}) as attrsLine
                    WHERE ${filter}
                    AND ${extractJsonFieldSql('attributes', `$.7266.${rawName}`)} in ('["Pressure-independent 6-way zone valve"]')
                    )
            ,user_input1 as (SELECT cast(? as float) as value)
            ,user_input2 as (SELECT cast(? as float) as value)
            ,bounds as (SELECT
                            max(user_input1.value, user_input2.value) * 1000 as maxLH
                        FROM user_input1 JOIN user_input2)
            , data as (SELECT
                           *
                       FROM product_filtered
                       JOIN bounds
                       WHERE vnom >= maxLH)
            , lownoise as (SELECT min(label) as bestlabel 
                           FROM data JOIN bounds 
                           WHERE Vmaxlown > bounds.maxLH OR Vmaxlown = 0 GROUP BY line)
            , count as (SELECT count(*) as count FROM data)
        SELECT ${selectFields}
        FROM data
        JOIN count    
        LEFT JOIN lownoise ON lownoise.bestlabel = data.label
         `,
        [volumetricFlow, volumetricFlow2]
    ];
}
